import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { changeNav } from "../../../redux/actions/userActions";
import { connect } from "react-redux";
import { carelineNumber, getStoreType } from "../../../dynamicController";
import Sidebar from "../utilities/Sidebar";
import WashupHeader from "./dashboard/header/washupHeader";
import { Card, CardGroup } from "react-bootstrap";
import axios from "axios";
import reloadPromotion from "../../../assets/images/news/reload_promotion.png";
import dngPromotion from "../../../assets/images/news/dng_promotion.png";
import laundrypassPromotion from "../../../assets/images/news/laundrypass_promotion.png";
import NewsSlider from "./dashboard/NewsSlider";

const STORETYPE = getStoreType()

const News = ({ changeNav, user, token }) => {
  const [toggled, setToggled] = useState(false);
  const [reload, setReload] = useState(null);
  const [dng, setDng] = useState(null);
  const [laundrypass, setLaundrypass] = useState(null);

  const history = useHistory();

  const { t } = useTranslation();

  useEffect(() => {
    if (STORETYPE !== "cleanpro" && STORETYPE !== "washup" && STORETYPE !== "jomcuci") {
      if (token) {
        axios.get("/api/user/getPromotion", { headers: { "Content-Type": "application/json", "auth-token": token } })
          .then(res => {
            const reloadData = res.data.data.find(item => item.type === "RELOAD");
            const dngData = res.data.data.find(item => item.type === "DNG");
            const laundrypassData = res.data.data.find(item => item.type === "LAUNDRY PASS");
            setReload(reloadData);
            setDng(dngData);
            setLaundrypass(laundrypassData);
          })
          .catch(err => {

          })
      }
    }
  }, [token])

  return (
    <div id={`${STORETYPE === "cleanpro" ? "support-page" : "news-page"}`}>
      <Sidebar toggled={toggled} setToggled={setToggled} />
      {
        STORETYPE === "washup" || STORETYPE === "jomcuci" ? (
          <WashupHeader user={user} setToggled={setToggled} />
        ) : (
          <div id="user-header">
            <h5>
              {STORETYPE === "cleanpro" ? (
                <strong onClick={(e) => changeNav("stamp")}>
                  <i className="bi bi-chevron-left me-3"></i>
                  {t("Support")}
                </strong>
              ) : (
                <>
                  <i
                    onClick={(e) => setToggled(true)}
                    className="bi bi-list me-3"
                  ></i>{" "}
                  <strong>{t("Promotion")}</strong>
                </>
              )}
            </h5>
          </div>
        )
      }

      <div id="user-body">
        {STORETYPE === "washup" || STORETYPE === "jomcuci" ?
          <NewsSlider page="news" history={history} /> :
          STORETYPE !== "cleanpro" ? (
            <CardGroup>
              {
                user.tokenSetting && ((reload && reload.show) || !reload) ? (
                  <Card onClick={() => history.push("/user/reload")}>
                    <Card.Img variant="top" src={reload && reload.image ? reload.image : reloadPromotion} />
                    <Card.Body style={{ padding: "0.5rem 1rem" }}>
                      <Card.Text>{t("Reload")}</Card.Text>
                    </Card.Body>
                  </Card>
                ) : null
              }
              {
                (laundrypass && laundrypass.show) || !laundrypass ? (
                  <Card onClick={() => history.push("/user/subscription")}>
                    <Card.Img variant="top" src={laundrypass && laundrypass.image ? laundrypass.image : laundrypassPromotion} />
                    <Card.Body style={{ padding: "0.5rem 1rem" }}>
                      <Card.Text>{t("Laundry Pass")}</Card.Text>
                    </Card.Body>
                  </Card>
                ) : null
              }
              {
                (dng && dng.show) || !dng ? (
                  <Card onClick={() => history.push("/user/dng/outlet")}>
                    <Card.Img variant="top" src={dng && dng.image ? dng.image : dngPromotion} />
                    <Card.Body style={{ padding: "0.5rem 1rem" }}>
                      <Card.Text>{t("Drop n Go Service")}</Card.Text>
                    </Card.Body>
                  </Card>
                ) : null
              }
            </CardGroup>
          ) : (
            <div className="px-3 py-2">
              <h1 className="font-weight-bold mt-2">{t("Need help?")}</h1>

              <h4 className="font-weight-bold mt-4">{t("24-Hour Careline Number")}</h4>
              <p>{carelineNumber(user.country)}</p>
              <a
                id="support-call-now"
                className="mt-2 d-block"
                style={{ textDecoration: "none" }}
                href={`tel:${carelineNumber(user.country)}`}
              >
                {t("Call Now")} <i className="bi bi-chevron-right me-3"></i>
              </a>
              {/* <h4 className="font-weight-bold mt-4">{t("Email Us")}</h4>
              <p>info@cleanprolaundry.com</p>
              <a
                id="support-email-now"
                className="mt-2 d-block"
                style={{ textDecoration: "none" }}
                href="mailto:info@cleanprolaundry.com"
              >
                {t("Email Now")} <i className="bi bi-chevron-right me-3"></i>
              </a> */}
            </div>
          )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    token: state.user.token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeNav: (nav) => dispatch(changeNav(nav)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(News);
